<template>
    <div class="compo-form-item">
        <div class="compo-form-name">
            <label class="compo-form-title">메시지</label>
            <a class="form-title-right" data-bs-toggle="collapse" href="#message-inputted-collapse" role="button" aria-expanded="true" aria-controls="message-inputted-collapse">
                <p class="txt-preview">{{productItem.externalMmsTitle}}</p>
                <img class="collapse-icon" src="@/assets/img/icon_down.svg" alt="드롭다운 화살표">
            </a>
        </div>
        <div class="collapse show" id="message-inputted-collapse">
            <div class="compo-form-body">
                <table class="key-value value-left">
                    <tr>
                        <th>제목</th>
                        <td>{{productItem.externalMmsTitle}}</td>
                    </tr>
                    <tr>
                        <th>내용</th>
                        <td>{{productItem.externalMmsContent}}</td>
                    </tr>
                </table>
            </div>
            <div class="compo-form-body bd">
                <table class="key-value value-left">
                    <tr>
                        <th>발신번호</th>
                        <td>{{productItem.externalOrderMobile}}</td>
                    </tr>
                </table>
            </div>
        </div>
        
        
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    components: { 
    
    },

    props: {
        productItem : {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            goodsId: null,
            product: [],
            useInfoTxt: null,
            goodsInfoTxt: null
        }
    },

    computed: {
        ...mapState({
            userData: state => state.userData,
            userNo: state => state.userNo,
        }),
    },

    created() {
        
    },

    mounted() {
        
    },

    methods: {
        
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/order.scss';

</style>